import React, { useEffect, useState } from "react"
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  Image,
  Alert,
  Platform,
  ActivityIndicator,
  Linking
} from "react-native"
import axios from "axios"
import moment from "moment"
import { useSelector } from "react-redux"
import API_PATHS from '../src/apiCalls/ApiPath'
import AsyncStorage from "@react-native-async-storage/async-storage"
// import { toast, ToastContainer } from "react-toastify"
import Toast from "react-native-toast-message";
import TopGreenHeader from "./screens/Common/TopGreenHeader"

const Invoices = ({ navigation }) => {
  const [invoices, setInvoices] = useState([])
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    fetchInvoices()
  }, [])

  const handleBack = () => {
    navigation.navigate("ProfileScreen")
  }

  const handleViewBookings = (item) => {
    if (item.bookingId !== null) {
      navigation.navigate("BookingDetails", {
        bookingId: item.bookingId,
      })
    } else {
      navigation.navigate("RecurringDetails", {
        recurringId: item.recurringId,
      })
    }
  }

  const fetchInvoices = async () => {
    const userId = await AsyncStorage.getItem("userId");
    console.log("userId ", userId);
    try {
      const response = await axios.post(`${API_PATHS.BASE_URL}${API_PATHS.GET_INVOICES}`, {
        parentId: userId,
      })

      if (response.data.Success === 1) {
        setInvoices(response.data.Data)
      } else {
        Toast.show({
          type: "error",
          text1: "Error fetching invoices! Please try again.",
        });
      }
    } catch (error) {
      Toast.show({
        type: "error",
        text1: "Error fetching invoices! Please try again.",
      });
    } finally {
      setLoading(false)
    }
  }

  const renderInvoice = ({ item }) => {
    const isPaid = item.status !== "DUE"
    const createdAt = moment.unix(item.createdAt).format("DD-MMM-YY");
    const createdAT = moment.unix(item.createdAt).format("hh:mm A");

    return (
      <TouchableOpacity
        onPress={() =>
          navigation.navigate("Profilebookings", {
            invoiceId: item.invoiceId,
            type: (item.bookingId == null && item.recurringId == null) ? 2 : 1
          })
        }
      >
        <View style={styles.invoiceCard}>
          <View style={styles.invoiceContent}>
            <Text style={styles.invoiceId}>
              Invoice Id: <Text style={styles.invoiceIdHighlight}>{item.invoiceId}</Text>
            </Text>
            <Text style={styles.date}>{createdAt}{", "}{createdAT}</Text>
            <Text style={[styles.status, item.status === "PAID" ? styles.paidText : styles.unpaidText]}>
              {item.status === "PAID" ? "PAID" : item.status === "PARTIALPAID" ? "PARTIAL" : "DUE"}
            </Text>
            <View style={styles.actionsContainer}>
              {(item.bookingId !== null || item.recurringId !== null) && (
                <TouchableOpacity
                  onPress={() => {
                    handleViewBookings(item)
                  }}
                  style={styles.actionButton}
                >
                  <Text style={styles.actionText}>View Booking</Text>
                </TouchableOpacity>
              )}
              {!isPaid && (
                <TouchableOpacity style={styles.actionButton} onPress={() => {
                  const invoiceLink = JSON.parse(item?.qbJSONString);
                  Linking.openURL(invoiceLink.Invoice.InvoiceLink);

                }}>
                  <Text style={styles.actionText}>Pay</Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
          <Image source={require("./assets/next1.png")} style={styles.nextIcon} />
        </View>
      </TouchableOpacity>
    )
  }

  return (
    <View style={styles.container}>
      {/* <ToastContainer /> */}
      <TopGreenHeader
        Heading={"Invoices"}
        navigation={navigation}
        isBackIcon={true}
        isNotification={false}
      />

      {loading ? (
        <ActivityIndicator
          size="large"
          color="#A6CE39"
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <FlatList
          data={invoices}
          keyExtractor={(item) => item.id.toString()}
          renderItem={renderInvoice}
          contentContainerStyle={styles.listContent}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  header: {
    backgroundColor: "#A6CE39",
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 20,
  },
  backIcon: {
    width: 14,
    height: 24,
  },
  headerTitle: {
    flex: 1,
    textAlign: "center",
    fontSize: 28,
    color: "#fff",
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "bold",
  },
  listContent: {
    paddingHorizontal: 10,
    paddingVertical: 2,
  },
  invoiceCard: {
    padding: 6,
    borderBottomWidth: 1,
    borderBottomColor: "#E0E0E0",
    backgroundColor: "#fff",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  invoiceContent: {
    flex: 1,
    marginLeft: "8%",
  },
  invoiceId: {
    fontSize: 18,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: "#8E8E93",
  },
  invoiceIdHighlight: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "#EE3897",
  },
  date: {
    fontSize: 16,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "noraml",
    fontWeight: "normal",
    color: "#000000",
  },
  status: {
    fontSize: 18,
  },
  paidText: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "#000000",
  },
  unpaidText: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "#000000",
  },
  actionsContainer: {
    flexDirection: "row",
    marginTop: 2,
  },
  actionButton: {
    backgroundColor: "#A6CE39",
    paddingVertical: 2,
    paddingHorizontal: 4,
    borderRadius: 1,
    marginRight: 10,
  },
  actionText: {
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "#fff",
    fontSize: 18,
  },
  nextIcon: {
    width: 12,
    height: 24,
  },
})

export default Invoices

